import "./FlowCheckbox.scss";
import { useState, useEffect } from "react";

function FlowCheckbox({
  checked = false,
  onChange,
  disabled = false,
  label,
  className = "",
}) {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    if (checked !== undefined) {
      setIsChecked(checked);
    }
  }, [checked]);

  const handleChange = (e) => {
    const newValue = e.target.checked;
    setIsChecked(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className={`flow-checkbox-container ${className}`}>
      <label className="flow-checkbox">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className="checkmark"></span>
      </label>
      {label && <span className="checkbox-label">{label}</span>}
    </div>
  );
}

export default FlowCheckbox;
